export default {"src":"/_next/static/media/positionOpposition.e00e7c11.svg","height":400,"width":401,"blurWidth":0,"blurHeight":0};